export default {
  data() {
    return {
      // 需要倒计时的秒数
      countNum: 60,
      // 当前倒计时秒数
      timeCount: 0,
      timer: null,
      //当前是否正在倒计时
      isCounting: false,
    };
  },
  methods: {
    // 校验sms参数
    checkSms() {
      return true;
    },
    // 发送sms接口
    fetchSmsApi() {},
    // 点击发送验证码按钮
    clickCodeBtn() {
      const { isCounting, countNum } = this;
      if (!this.checkSms()) return;
      if (isCounting) return;

      this.timeCount = countNum;
      this.isCounting = true;
      this.fetchSmsApi();

      this.timer = setInterval(() => {
        this.timeCount = this.timeCount - 1;
        if (this.timeCount <= 0) {
          this.isCounting = false;
          clearInterval(this.timer);
        }
      }, 1000);
    },
    destroyTimer() {
      this.isCounting = false;
      this.timer = null;
      clearInterval(this.timer);
    },
  },
};
